<template>
  <div v-if="readNotifications.length">
    <div class="m-4">
      <div class="flex items-baseline justify-between">
        <h4
          class="uppercase"
          v-text="'All notifications'"
        />
      </div>
      <ul class="list-reset my-4">
        <li
          :is="notification.attributes.type"
          v-for="notification in readNotifications"
          :key="notification.id"
          :notification="notification"
          class="opacity-50"
        />
      </ul>
      <div class="flex justify-between">
        <button
          type="button"
          class="btn btn--sm"
          :disabled="!prevLink"
          :aria-disabled="!prevLink"
          @click="paginate('prev')"
          v-text="'prev'"
        />
        <button
          type="button"
          class="btn btn--sm"
          :disabled="!nextLink"
          :aria-disabled="!nextLink"
          @click="paginate"
          v-text="'next'"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import NotificationFeedMixin from './NotificationFeedMixin'

export default {
  name: 'ReadNotifications',
  mixins: [NotificationFeedMixin],
  computed: {
    prevLink() {
      return this.$store.state.notification.read._links.prev
    },
    nextLink() {
      return this.$store.state.notification.read._links.next
    },
    readNotifications() {
      return this.$store.state.notification.read.data
    },
  },
  async mounted() {
    await this.$nextTick()

    this.$store.dispatch('notificationGetNotifications', { type: 'read' })
  },
  methods: {
    paginate(direction = 'next') {
      this.$store.dispatch('notificationGetNotifications', {
        url: direction === 'next' ? this.nextLink : this.prevLink,
        type: 'read',
      })
    },
  },
}
</script>
